var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#linkedin_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#929292",
    d: "M13.863 2.728H6.136a3.41 3.41 0 0 0-3.41 3.409v7.727a3.41 3.41 0 0 0 3.41 3.409h7.727a3.41 3.41 0 0 0 3.409-3.41V6.138a3.41 3.41 0 0 0-3.41-3.41"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEDE",
    d: "M14.829.91h-9.66A4.26 4.26 0 0 0 .91 5.17v9.66a4.26 4.26 0 0 0 4.26 4.261h9.66a4.26 4.26 0 0 0 4.261-4.261V5.17A4.26 4.26 0 0 0 14.829.91"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#929292",
    d: "M13.224 15.096h1.663a.227.227 0 0 0 .227-.227v-3.514c0-1.836-.395-3.248-2.541-3.248a2.23 2.23 0 0 0-2 1.093.018.018 0 0 1-.034-.01v-.686a.227.227 0 0 0-.228-.227H8.733a.227.227 0 0 0-.227.227v6.365c0 .125.102.227.227.227h1.663a.227.227 0 0 0 .227-.227v-3.147c0-.89.17-1.75 1.272-1.75 1.087 0 1.101 1.017 1.101 1.808v3.089c0 .125.102.227.228.227M4.887 6.116c0 .674.555 1.228 1.229 1.228s1.228-.555 1.228-1.229-.554-1.228-1.228-1.228c-.675 0-1.23.554-1.23 1.229M5.282 15.096h1.665a.227.227 0 0 0 .227-.227V8.504a.227.227 0 0 0-.227-.228H5.282a.227.227 0 0 0-.227.228v6.365c0 .125.101.227.227.227"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "linkedin_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgLinkedin;